import { useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';
import { LOCAL_STORAGE } from '../constants/constants';
import { hasAccessLevel, itAccessIds, userAccessIds } from '../constants/access-ids';

export const useAccessLevel = () => {
    return useMemo(() => {
        try {
            const token = localStorage.getItem(LOCAL_STORAGE.JJ_INTERNAL);
            if (!token) return { itAccess: false, userAccess: false, userGroups: [] };

            const userGroups = jwtDecode(token).groups ?? [];
            return {
                itAccess:   hasAccessLevel(userGroups, itAccessIds),
                userAccess: hasAccessLevel(userGroups, userAccessIds),
                userGroups,
            };
        } catch {
            return { itAccess: false, userAccess: false, userGroups: [] };
        }
    }, []);
};

export default useAccessLevel;